export default {
  forgotPassword: {
    "title": "Forgot password",
    "description": "Enter your email and you will receive an email to recover your password",
    "submitButton": "Recover password",
    "returnButton": "Return",
    "requiredMailRule": "Please input email",
    "typeMailRule": "Please input correct email address",
  }
}